import {
  get,
  post,
  put,
  destroy
} from 'app/services/ApiService';

import {
  SEARCH_MARKETING_URL,
  MARKETINGS_URL,
  MARKETING_URL,
  MARKETING_IMAGE_UPLOAD_URL
} from 'app/utils/Constants';

export const getMarketing = async params => {
  return await post(SEARCH_MARKETING_URL(), params);
}

export const createMarketing = async (params) => {
  return await post(MARKETINGS_URL(), params);
}

export const updateMarketing = async (marketingId, params) => {
  return await put(MARKETING_URL(marketingId), params);
}

export const deleteMarketing = async (marketingId) => {
  return await destroy(MARKETING_URL(marketingId));
}

export const uploadSignMarketingImage = async (marketingId, contentType) => {
  return await get(MARKETING_IMAGE_UPLOAD_URL(marketingId, contentType));
}
